import { Box, Button, Paper, Popover, useMediaQuery } from "@mui/material";
import { EmojiPicker } from "frimousse";
import { useState } from "react";
import EmojiComponentList from "../Components/Chat/EmojiPickerList";

const EmojiComponent = ({ setInputValue }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const open = Boolean(anchorEl);
    const id = open ? 'emoji-popover' : undefined;
    return (
        <div>
            <Button
                aria-describedby={id}
                onClick={handleClick}
                sx={{ display: {xs: 'none', md: 'flex'}, minWidth: 'auto', p: 1, height: '100%' }}
            >
                Emoji
            </Button>

            <Popover
                disableScrollLock
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',    // Anchor to the top of the button
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom', // Align the bottom of the picker to that anchor
                    horizontal: 'center',
                }}
                // This adds a little gap so it doesn't touch the button
                slotProps={{ paper: { sx: { mb: 1, borderRadius: '12px' } } }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        width: useMediaQuery('(max-width:1300px)') ? 'fit-content' : '15vw',
                        height: '42vh',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    <EmojiPicker.Root style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Box sx={{ p: 1, borderBottom: '1px solid #eee' }}>
                            <EmojiPicker.Search
                                style={{
                                    width: '100%', padding: '8px',
                                    borderRadius: '6px', border: '1px solid #ccc'
                                }}
                                placeholder="Search emojis..."
                            />
                        </Box>
                        <EmojiComponentList setInputValue={setInputValue} />
                    </EmojiPicker.Root>
                </Paper>
            </Popover>
        </div>
    );
}

export default EmojiComponent;